import { render, staticRenderFns } from "./ModalBulkPrintShippingLabel.vue?vue&type=template&id=35136cb7&"
import script from "./ModalBulkPrintShippingLabel.vue?vue&type=script&lang=js&"
export * from "./ModalBulkPrintShippingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports